(() => {
  if (document.documentElement.dataset.solPairBound) return;
  document.documentElement.dataset.solPairBound = 'true';
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.sol-pair-form').forEach(form => {
      delete form.dataset.submitting;
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = false;
      form.removeAttribute('aria-busy');
    });
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.sol-pair-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const status = form.querySelector('.sol-pair__status');
    const cartLink = form.querySelector('.sol-pair__cart');
    const selected = [...form.querySelectorAll('select')].map(select => Number(select.value));
    if (selected.length !== 2 || selected.some(id => !Number.isSafeInteger(id) || id <= 0)) return;
    const quantities = new Map();
    selected.forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
    const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    const label = button.innerHTML;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = form.dataset.adding;
    let confirmedFailure = false;
    try {
      const response = await fetch(form.action + '.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const data = await response.json();
      if (!response.ok) {
        confirmedFailure = true;
        throw new Error(data.description || data.message || form.dataset.error);
      }
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      status.textContent = confirmedFailure ? error.message : form.dataset.error;
      cartLink.hidden = false;
      form.removeAttribute('aria-busy');
      if (confirmedFailure) {
        button.disabled = false;
        delete form.dataset.submitting;
      }
      button.innerHTML = label;
    }
  }, true);
})();
